/**
 * Return link summary
 */
export const extractSummary = jsonLd => {
  if (typeof (jsonLd === null || jsonLd === void 0 ? void 0 : jsonLd.summary) === 'string') {
    const summary = jsonLd.summary.trim();
    return Boolean(summary) ? summary : undefined;
  }
};